import {DataCell, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import TableRow from "@material-ui/core/TableRow";
import {AutoCompleteUnControlled} from "../../../Utils/FormInputs/AutoCompleteInput";
import TextField from "../../../Utils/FormInputs/TextField";
import {ErrorMessage} from "../../../Utils/styledComponents";
import InputGroup from "react-bootstrap/InputGroup";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {StyledCell, StyledRemoveIcon} from "../../../DoctorsModule/doctorStyles";
import React, {useState} from "react";
import {titleCase} from "../../../Users/addUser";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import {BlockNavigationComponent} from "../../../Utils/ReusableComponents/BlockNavigationComponent";
import {history} from "../../../../Helpers/history";
import {ConfirmationDialog} from "../../../Utils/ReusableComponents/ConfirmationDialog";

const headData = [{item:'Procedure', isRequired:true},{item:'Quantity', isRequired:true},{item:'Cost', isRequired:false},{item:'Action', isRequired:false}]

const AddGynProcedure = ({actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                                 isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog}) =>{

    const initialState = [{procedure_id: '', service_name: '', showProcedure: false,
        service_id: '', isError: false, rate:0, currency:'', currency_symbol:'', quantity:1}]

    const [all_procedures, setAllProcedures] = useState([]);
    const [procedures, setProcedures] = useState(initialState);
    const [submitted, setSubmitted] = useState(false)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [cashItems, setCashItems] = useState([])
    const [procedure_id, setProcedureId] = useState('')

    const retrieveAllProcedures = (event, idx) => {
        const arr = procedures.map((prod, index) => {
            if (index === idx) {
                const formData = new FormData();
                formData.append('procedure_name', titleCase(event));
                prod.service_name = event;
                if (event !== '') {
                    axios.post(`${config.smsUrl}/cdoctor/autocomplete_search_procedure`, formData).then(res => {
                        const data = res.data;
                        const dt = !data ? [] : data;
                        if (dt[0] === "No Procedure Found") {
                            setAllProcedures([{value: '', label: 'No procedure found'}])
                        } else {
                            setAllProcedures(dt);
                        }
                    }).catch(error => {
                        logoutErrorMessage(error, null, actions)
                    });
                }
                prod.showProcedure = true;
                prod.isError = false;
                return prod
            }
            return prod
        })
        setProcedures(arr)
        setIsSubmitted('idle')
        setIsBlocking(true)
    };

    const getProcedureDetails = (event, idx) => {
        let arr = procedures.map((item, index)=>{
            if(index === idx){
                return {...item,service_name:event.innerText, procedure_id:event.value, isError:false, showProcedure:false}
            }
            return item
        })
        const formData = new FormData();
        formData.append('procedure_id', event.value);
        if (event.value) {
            axios.post(`${config.smsUrl}/cdoctor/get_service_id_by_procedure_id`, formData).then(res => {
                const resp = res.data;
                const data = !resp ? {} : resp;
                const {service_id} = data;
                axios.post(`${config.smsUrl}/cbilling/item_cost`, {visit_id:+visit_id, item_id:service_id, item_type:'service'}).then(res => {
                    const resObj = res.data;
                    const dataObj = !resObj.data ? {} : resObj.data;
                    arr = arr.map((item, index)=>{
                        if(index === idx){
                            return {...item,currency: dataObj.currency_id, service_id, currency_symbol: dataObj.currency,rate:dataObj.cost ?? 0, ...dataObj}
                        }
                        return item
                    })
                    setProcedures(arr)
                    if(dataObj.is_provider === 1 && dataObj.is_provided === 0){
                        setProcedureId(data.procedure_id)
                        setOpenConfirmation(true)
                    }
                }).catch(error => {
                    errorMessages(error, null, actions)
                });
            }).catch(error => {
                errorMessages(error, null, actions)
            });
        }
        setIsBlocking(true)
    };

    const handleChangeProcedureQuantity = (e, idx)=> {
        let arr = procedures.map((item, index) => {
            if (index === idx) {
                return {...item, quantity: e.target.value}
            }
            return item
        })
        setProcedures(arr)
    }

    const addItemsToReceipt = () =>{
        const arr = procedures.filter(item=>item.procedure_id === procedure_id)
        setCashItems(arr)
        setOpenConfirmation(false)
    }

    const handleCloseConfirmation = () =>{
        const arr = procedures.filter(item=>item.procedure_id !== procedure_id)
        setProcedures(arr)
        setOpenConfirmation(false)
    }

    const handleCancelConfirmation = () =>{
        setOpenConfirmation(false)
    }

    const handleAddRow = () => {
        setProcedures([...procedures, ...initialState])
        setIsSubmitted('idle')
    };

    const removeRow = (index) => {
        const arr = procedures.filter((_, idx) => idx !== index)
        setProcedures(arr);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const arr = procedures.every(prod => prod.service_id && prod.procedure_id && prod.quantity)
        setSubmitted(true)
        if (arr) {
            setIsSubmitted('pending');
            const params = {
                visit_id, result_type: 1,bill_type:2,
                bill_details: procedures.filter(prod => prod.service_id && prod.procedure_id).map(({procedure_id, service_id, quantity,rate,...item}) => ({
                    procedure_id,
                    service_id,
                    quantity:+quantity,
                    rate,
                    is_provided: item.is_provided,
                    is_provider: item.is_provider,
                    currency_id:item.currency_id
                }))
            }
            setIsBlocking(false)
            // const url = patient_type === '1' ? 'add_procedure' : 'save_inpatient_procedure'
            axios.post(`${config.smsUrl}/cdoctor/add_procedure`, {...params}).then(() => {
                actions.snackbarActions.snackSuccess('Procedure added successfully');
                setIsSubmitted('resolved');
                setSubmitted(false)
                setOpenDialog(false)
                setProcedures(initialState)
            }).catch(err => {
                errorMessages(err, null, actions)
                setIsSubmitted('rejected');
            })
        }
    };

    const handleResetForm = () =>{
        setIsBlockDialog(false)
        setIsBlocking(false)
        setOpenDialog(false);
        setSubmitted(false);
        const arr= procedures.map(item=>({
            ...item,procedure_id: '', service_name: '', showProcedure: false,quantity:1,
            service_id: '', isError: false, rate:0,qty:1, currency:'', currency_symbol:''
        }))
        setProcedures(arr)
    }

    const isPending = isSubmitted === 'pending'

    return (
        <div>
            <BlockNavigationComponent
                when={isBlocking}
                shouldBlockNavigation={()=>{
                    return isBlocking;
                }}
                navigate={path=>history.push(path)}
                dialogClose={isBlockDialog}
                setIsBlockDialog={setIsBlockDialog}
                clearForm={handleResetForm}
            />
            <ConfirmationDialog open={openConfirmation} handleClose={handleCancelConfirmation}
                                title='Make cash payment'
                                confirmItems={addItemsToReceipt}
                                removeItems={handleCloseConfirmation} service='procedure'/>
            <form onSubmit={handleSubmit}>
                <ModuleTable headData={headData}>
                    {procedures.map((test, index) => (
                        <TableRow
                            key={index}
                        >
                            <DataCell variant='200'>
                                <AutoCompleteUnControlled options={all_procedures} submitted={submitted} idx={index}
                                                          handleChange={retrieveAllProcedures} label_text="label"
                                                          medicine_value={{
                                                              label: test.service_name,
                                                              value: test.service_id
                                                          }} id="service_name" value_text="value"
                                                          valid_error_check={test.isError}
                                                          errorMsg_Valid="Please a select a valid procedure"
                                                          testId={`procedure_name-${index}`}
                                                          handleProductData={getProcedureDetails}
                                                          placeholder="Type procedure"
                                                          errorMsg="procedure is required"/>

                            </DataCell>
                            <DataCell variant='200'>
                                <TextField submitted={submitted} id='service_quantity'
                                           value={test.quantity} name='quantity'
                                           data-test="service_quantity"
                                           onChange={e => handleChangeProcedureQuantity(e, index)}/>
                                {(submitted && test.quantity) &&
                                    <ErrorMessage>Quantity is required</ErrorMessage>}
                            </DataCell>
                            <DataCell variant='150'>
                                <InputGroup>
                                    <InputGroup.Text style={{borderRadius: '0.7rem 0 0 0.7rem'}}
                                                     id="basic-addon1">{test.currency_symbol}</InputGroup.Text>
                                    <TextField type="number" value={test.rate} style={{pointerEvents: 'none'}}/>
                                </InputGroup>
                            </DataCell>
                            <DataCell>
                                <Tooltip title='Remove'>
                                    <IconButton type='button' onClick={() => removeRow(index, test)}>
                                        <StyledRemoveIcon/>
                                    </IconButton>
                                </Tooltip>
                            </DataCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <StyledCell colSpan={headData.length}>
                            <button type="button" onClick={handleAddRow} className="btn btn-sm sms-gray-btn"
                                    id="add-row">Add another line
                            </button>
                        </StyledCell>
                    </TableRow>

                </ModuleTable>
                <button type='submit' className='btn sms-btn btn-sm'
                        disabled={isPending}>{isPending ? 'Saving...' : 'Save Procedure'}</button>

            </form>

        </div>

    )
}

export {AddGynProcedure}